var timelineComponent = function (element) {
  var self = {
    init: function () {
      if (_THULEDATA.IsEditing) {
        return;
      }

      self.setupTimeLineMenu();
    },

    //Scroll timeline menu to the currently selected year when the page loads
    setupTimeLineMenu: function () {
      var timelineMenu = document.querySelector('.timeline-menu');
      var link = timelineMenu.querySelector('.timeline-menu-link.active');
      if (!link) {
        link = Array.from(timelineMenu.querySelectorAll('.timeline-menu-link'))[0];
      }
      timelineMenu.scroll({ left: 0 });
      var windowWidth = window.innerWidth;
      var linkwidth = link.offsetWidth;
      var targetleft = windowWidth / 2 - linkwidth / 2;
      var currentleft = link.getBoundingClientRect().left + window.scrollX;
      var scrollDiff = timelineMenu.scrollLeft + Math.abs(targetleft - currentleft);
      timelineMenu.scroll({ left: scrollDiff });
    },
  };
  return self;
};

document.addEventListener('DOMContentLoaded', function () {
  let timelineDiv = document.querySelector('.timeline-component');

  if (timelineDiv != null) {
    let timeline = new timelineComponent(timelineDiv);
    timeline.init();
  }
});
